module.exports = __webpack_public_path__ + "static/media/bf6a2464-659a-41ff-9f57-f7bbd9c416e4.c32537af.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/bf6a2464-659a-41ff-9f57-f7bbd9c416e4.jpg
// module id = 849
// module chunks = 0